export const UrlParamsMixin = {
    data() {
        return {
            urlParams: {},
            urlParamsUrl: '',
        }
    },
    mounted() {
        this.urlParamsUrl = window.location.href.split('?')[0]
        this.urlParamsReadUrl()
    },
    methods: {
        /**
         * Retrieve an item in the url parameters
         * @param name
         * @param defaultValue
         * @returns {null|*}
         */
        urlParamsGet(name, defaultValue = null) {
            this.urlParamsReadUrl()
            if (!(name in this.urlParams)) {
                return defaultValue
            }

            return this.urlParams[name]
        },
        /**
         * Add / Set an Item in the Url Parameters
         * @param name
         * @param value
         * @returns {*}
         */
        urlParamsStore(name, value) {
            console.log(`Adding: ${name} => ${value}`)
            if (name === '') {
                return
            }
            this.urlParams[name] = value
            this.urlParamsWriteUrl()
            return this.urlParamsGet(name)
        },
        /**
         * Remove an item from the url parameters
         * @param name
         * @returns {boolean}
         */
        urlParamsRemove(name) {
            if (!(name in this.urlParams)) {
                return false
            }
            delete this.urlParams[name]
            this.urlParamsWriteUrl()

            return true
        },
        /**
         * Get all the url Parameters
         * @returns {{}}
         */
        urlParamsGetAll() {
            this.urlParamsReadUrl()
            return this.urlParams
        },

        /**
         * Internal
         * Read Parameters in from the url
         */
        urlParamsReadUrl(){
            const urlSearchParams = new URLSearchParams(window.location.search)
            const data = {}

            urlSearchParams.forEach((value, key) => {
                data[key] = value
            })

            this.urlParams = data
        },
        /**
         * Internal
         * Writes out url parameters into the url
         */
        urlParamsWriteUrl() {
            const urlSearchParams = new URLSearchParams()

            Object.keys(this.urlParams).forEach(key => {
                if (key !== '') {
                    urlSearchParams.set(key, this.urlParams[key])
                }
            })

            let url = window.location.pathname
            const queryString = urlSearchParams.toString()
            if (queryString !== '') {
                url += `?${queryString}`
            }

            window.history.pushState(window.location.hostname, "", url)
        },
        /**
         * Set all of the url Parameters
         * @param params
         */
        urlParamsSetParams(params) {
            this.urlParams = params
            this.urlParamsWriteUrl()
        },
        urlParamsHas(key) {
            return Object.keys(this.urlParams).indexOf(key) !== -1
        }
    },
    computed: {

    },
}
